import axios from 'axios'
import { camelizeKeys } from 'humps'

import type { RawResponse } from './types'

const CONTENT_URL = process.env.CONTENT_URL
const MENU_PATH = `/site_options/site-options-en-us`

export async function fetch() {
  const response = await axios
    .get(`${CONTENT_URL}?full_path=${MENU_PATH}`)
    .then((response) => (camelizeKeys(response.data) as unknown) as RawResponse)

  return response.tiles[0].acf
}
